module.exports = __webpack_public_path__ + "images/5128107884c5dae46ed10e3677b32f38.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/adventures_logo.png
// module id = 1275
// module chunks = 0